// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".atm-modal-width .modal-dialog {\n  max-width: 90% !important;\n}\n[dir] #modal_product_price_option div[data-type=number-stepper] .formulate-input-errors > .formulate-input-error {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
